<template>
  <div class="container desktopOnly">
    <ul class="BreadCrumbs">
      <li v-for="(item, index) in breadcrumbs" :key="index">
        <ObfuscateLink v-if="isObfuscate && item.link" :dataHref="item.link">
            <template v-slot:content>
              {{ item.label }}
            </template>
        </ObfuscateLink>
        <template v-else>
          <a :href="item.link" v-if="item.link" :title="item.title">{{ item.label }}</a>
        </template>

        <strong v-if="index == breadcrumbs.length - 1">{{ item.label }}</strong>
        <template v-else>
          <ObfuscateLink v-if="isObfuscate && item.url" :dataHref="item.url">
              <template v-slot:content>
                {{ item.label }}
              </template>
          </ObfuscateLink>
          <template v-else>
            <a :href="item.url" v-if="item.url">{{ item.label }}</a>
          </template>
        </template>

        <span v-if="index != breadcrumbs.length - 1">/</span>
      </li>
    </ul>
  </div>
</template>

<script>
import "@/components/BreadCrumbs/BreadCrumbs.scss";
import ObfuscateLink from '@/components/ObfuscateLink/ObfuscateLink.vue';

export default {
  name: "BreadCrumbs",

  components: { 
      ObfuscateLink
  },

  props: {
    breadcrumbs: Array,
    isObfuscate: {
        type: Boolean,
        required: false,
        default: false,
    },
  },

  mounted() {
      if( document.querySelector('body').classList.contains('catalog-product-view') ){
          this.isObfuscate = true;
      }
  },
};
</script>
